import React, { useContext, useEffect, useState } from "react"
import ParkingViolationContext from "../../../Context/Violation/ParkingViolationContext"
import NoContent from "../../../Components/Common/NoContent"
import ActivityLoader from "../../../Components/Common/ActivityLoader"
import PageContainer from "../../../Components/Layout/PageContainer"
import PageHeader from "../../../Components/Common/PageHeader"
import dictionary from "../../../utils/dictionary"
import TableHeader from "../../../Components/Common/TableHeader"
import LoadMoreButton from "../../../Components/Other/LoadMoreButton"
import { Link } from "react-router-dom"
import PopReportClamp from "../../../Components/Operations/Violation/PopReportClamp"
import functions from "../../../utils/functions"
import ClampActionButton from "../../../Components/Operations/Violation/ClampActionButton"
import PopCancelClamp from "../../../Components/Operations/Violation/PopCancelClamp"
import ViolationFilter from "../../../Components/Operations/Violation/ViolationFilter"
import PopViewImage from "../../../Components/PopViewImage"
import useStateCallback from "../../../utils/customHooks/useStateCallback"
import PopRestoreClamp from "../../../Components/Operations/Violation/PopRestoreClamp"

const ParkingEnforcementPage =(props)=>{

    const { 
            allTransactions, 
            goToNextPage,
            getAllTransactions,
            setData,
            resetData,
            filterData,
            metaData,
            loading 
        } = useContext(ParkingViolationContext)

    const [selection, setSelection] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalId, setModalId] = useState(false);
    const [imageViewer, setImageViewer] = useStateCallback(false);

    useEffect(()=>{
        if(modal){
            functions.openPopup(modalId)
        }
    }, [modal])

    const handleReportClamp=()=>{
        setModal(false);
        setModalId("modal_clamp");
        setTimeout(() => {
            setModal(<PopReportClamp/>)
        }, 100);
       
    }

    const handleCancelClamp=()=>{

        setModal(false);
        setModalId("modal_cancel_clamp");
        setTimeout(() => {
            setModal(<PopCancelClamp record={selection}/>)
        }, 100);
        
    }


    const handleClampAction=(nModalId, nModal)=>{
        setModal(false);
        setModalId(nModalId);
        setSelection(false)
        setTimeout(() => {
            setModal(nModal())
        }, 100);
    }

    const handleRestoreClamp=()=>{

        setModal(false);
        setModalId("modal_restore_clamp");
        setTimeout(() => {
            setModal(<PopRestoreClamp record={selection}/>)
        }, 100);
        
    }


    
    const RenderFilter = () => {
            
        return <ViolationFilter/>

    }

    const onClickViewPhoto = (record) => {
        setImageViewer(false, ()=>{
            setImageViewer(<PopViewImage path={record?.initial_photo?.path} />, ()=>{
                functions.openPopup('modal_view_image')
            })
        })

    }


    const buttons = () => {
        return (
            <>
                <ClampActionButton clampRecord={selection} action={handleClampAction}/>
                {allTransactions  && 
                <a href="#" className="btn ripple btn-secondary navresponsive-toggler" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <i className="fe fe-filter mr-1"></i>  Filter <i className="fas fa-caret-down ml-1"></i>
                </a>
                }



             <a className="btn ripple btn-light dropdown-toggle" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <i className="fa fa-cog mr-1"></i> Options <i className="fas fa-caret-down ml-1"></i>
              </a>
              <div className="dropdown-menu tx-13">
                   <Link to="#" className="dropdown-item" onClick={handleReportClamp}>
                    <i className="fas fa-edit text-success mr-2"></i>New Vehicle Clamp</Link>

                    {selection && <>
                        <Link to="#" className="dropdown-item" onClick={handleCancelClamp}>
                        <i className="fas fa-times text-danger mr-2"></i>Clamp incident...</Link>
                        <Link to="#" className="dropdown-item" onClick={handleRestoreClamp}>
                        <i className="fas fa-undo text-success mr-2"></i>Restore Clamp</Link>
                    </>}  

                        <Link to="/enforcement/nonpayments" className="dropdown-item">
                        <i className="fas fa-list text-primary mr-2"></i>Non Payments</Link>

                        <Link to="/clamp/history" className="dropdown-item">
                        <i className="fas fa-clock text-danger mr-2"></i>Clamp History</Link>
                    

                    <Link to="#" className="dropdown-item" onClick={getAllTransactions}>
                    <i className="fa fa-redo text-dark mr-2"></i>Refresh</Link>

                  

              </div>


      
            </>
        )
      }

    return  <PageContainer>

                <PageHeader
                    title="Clamp Transactions"
                    previousPageTitle="Dashboard"
                    back="/operations"
                    buttons={buttons()}
                    />
                 {modal}
                 {imageViewer}
                 {RenderFilter()}

                 <div className="row">
                  <div className="col-sm-12 col-xl-12 col-lg-12">

                    <div className="card custom-card">
                        <div className="card-body map-card">

                          <TableHeader
                                    title={"Clamp transactions "}
                                    subtitle="List of all clamp transactions"
                                />

                            
                             {Array.isArray(allTransactions) &&
                                                            <LoadMoreButton
                                                                action={goToNextPage}
                                                                loading={loading}
                                                                title={metaData.current_page + " of " + metaData.total_pages}
                                                            />
                                                        }
                        
                            <div className="table-responsive allView-table border-top">


                                    {Array.isArray(allTransactions) &&
                                        <table id="table-parking-enforcement" export-format={dictionary._exportBtnFormats} className="table text-nowrap table-hover mg-b-0 datatable">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Clamp ref</th>
                                                    <th>Vehicle</th>
                                                    <th>Evidence</th>
                                                    <th>Incident Date</th>
                                                    <th>Location</th>
                                                    <th>Street</th>
                                                    <th>Status</th>
                                                    <th>Last Updated</th>
                                                    <th>Clamp Cause</th>
                                                    <th>Violation</th>
                                                    <th>Reported By</th>
                                                    <th>Clamped By</th>
                                                    <th>Clamping Location</th>
                                                    <th>Unclamped By</th>
                                                    <th>Clamp Incident</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {allTransactions.map((item, key)=>
                                                    <tr key={key} onClick={()=>setSelection(item)} className={`${item.transaction_id*1==selection.transaction_id && 'flag-row'}`}>
                                                        <td>{key + 1}</td>
                                                        <td>{item.ref}</td>
                                                        <td>{item.vehicle.plate_number}</td>
                                                        <td className="pointer">
                                                            <div className="main-img-user">
                                                                <img alt="avatar" onClick={() => onClickViewPhoto(item)} src={item?.initial_photo?.path} />
                                                            </div>
                                                        </td>
                                                        <td>{item.created_at.short_date + " " + item.created_at.time}</td>
                                                        <td>{item.initial_location.location_name}</td>
                                                        <td>{item.initial_location.street.street_name}</td>
                                                        <td style={{fontSize:'12px'}}>{item.status}</td>
                                                        <td>{item.updated_at.short_date + " " + item.updated_at.time}</td>
                                                        <td>{item.clamped_for.cause.cause}</td>
                                                        <td>{item.clamped_for.violation_name}</td>
                                                        <td>{item.reported_by.full_name}</td>
                                                        <td>{item.clamped_by.full_name}</td>
                                                        <td>{item.clamping_location.location_name} {item.clamping_location?item.clamping_location.street.street_name : ''}</td>
                                                        <td>{item.unclamped_by.full_name}</td>
                                                        <td>{item.incident?<span><b>{item.incident.reason.reason}</b> effected by <i>{item.incident.cancelled_by.full_name}</i></span> : <span style={{fontSize:'12px'}}>NO INCIDENT REPORTED</span>}</td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>}


                                        {(allTransactions === "404") && <NoContent />}
                                        {!allTransactions && <ActivityLoader />}
                                </div>

                            </div>
                        </div>
                    </div>
        </div>
</PageContainer>}


export default ParkingEnforcementPage